module.exports = __webpack_public_path__ + "media/assets/site_images/apple_store-9051a88b761ed7bff247d3c3b6775625.png";